// import React, {Fragment} from 'react';

const sandals = {
  primaryMenu: [
    {
      label: 'Resorts',
      link: '//www.sandals.com/resorts'
    },
    {
      label: 'Our Islands',
      link: '//www.sandals.com/destinations/'
    },
    {
      label: 'Inclusions',
      link: '//www.sandals.com/all-inclusive/#inclusions'
    },
    {
      label: 'Weddings ',
      subLabel: '& Honeymoons',
      link: '//www.sandals.com/weddingmoons/'
    },
    {
      label: 'Specials',
      link: '//www.sandals.com/specials/'
    }
  ],
  secondaryMenu: [
    {
      label: 'About Sandals',
      link: '//www.sandals.com/about/'
    },
    {
      label: 'Our Brands',
      link: '//www.sandals.com/about/resort-brands/'
    },
    {
      label: 'Sandals Select Rewards',
      link: '//www.sandals.com/about/rewards-program/'
    },
    {
      label: 'Sandals Foundation',
      link: '//www.sandals.com/sandals-foundation/'
    },
    {
      label: 'What\'s new',
      link: '//www.sandals.com/all-inclusive/whats-new/'
    },
    {
      label: 'Eco Friendly',
      link: '//www.sandals.com/about/eco-friendly/'
    },
    {
      label: 'Request Brochure',
      link: '//www.sandals.com/contact/request-brochure/'
    }
  ],
  menuBlocks: {
    resorts: [
      {
        country: {
          label: 'CURAÇAO',
          link: '//www.sandals.com/curacao/',
        },
        resortList: [
          {
            resortName: 'Royal Curaçao',
            link: '//www.sandals.com/royal-curacao/',
            value: 'scr',
            isNew: true,
          }
        ]
      },
      {
        country: {
          label: 'JAMAICA',
          link: '//www.sandals.com/jamaica/'
        },
        resortList: [
          {
            resortName: 'Montego Bay',
            link: '//www.sandals.com/montego-bay/',
            value: 'smb'
          },
          {
            resortName: 'Royal Caribbean',
            link: '//www.sandals.com/royal-caribbean/',
            value: 'src'
          },
          {
            resortName: 'Negril',
            link: '//www.sandals.com/negril/',
            value: 'sng'
          },
          {
            resortName: 'Royal Plantation',
            link: '//www.sandals.com/royal-plantation/',
            value: 'brp'
          },
          {
            resortName: 'Ochi',
            link: '//www.sandals.com/ochi/',
            value: 'sgo'
          },
          // {
          //   resortName: 'Inn',
          //   link: '//www.sandals.com/sandals-inn/',
          //   value: 'inn'
          // },
          {
            resortName: 'South Coast',
            link: '//www.sandals.com/south-coast/',
            value: 'swh'
          },
          {
            resortName: "Dunn's River",
            link: '//www.sandals.com/dunns-river/',
            value: 'sdr',
            isNew: true
          }
        ]
      },
      {
        country: {
          label: 'BAHAMAS',
          link: '//www.sandals.com/bahamas/'
        },
        resortList: [
          {
            resortName: 'Royal Bahamian',
            link: '//www.sandals.com/royal-bahamian/',
            value: 'srb',
            isNew: true
          },
          {
            resortName: 'Emerald Bay',
            link: '//www.sandals.com/emerald-bay/',
            value: 'seb'
          }
        ]
      },
      {
        country: {
          label: 'SAINT LUCIA',
          link: '//www.sandals.com/saint-lucia/',
        },
        resortList: [
          {
            resortName: 'Regency LaToc',
            link: '//www.sandals.com/regency-la-toc/',
            value: 'slu'
          },
          {
            resortName: 'Grande St. Lucian',
            link: '//www.sandals.com/grande-st-lucian/',
            value: 'sgl'
          },
          {
            resortName: 'Halcyon Beach',
            link: '//www.sandals.com/halcyon-beach/',
            value: 'shc'
          }
        ]
      },
      {
        country: {
          label: 'ANTIGUA',
          link: '//www.sandals.com/antigua/',
        },
        resortList: [
          {
            resortName: 'Grande Antigua',
            link: '//www.sandals.com/grande-antigua/',
            value: 'sat'
          }
        ]
      },
      {
        country: {
          label: 'GRENADA',
          link: '//www.sandals.com/grenada/',
        },
        resortList: [
          {
            resortName: 'Grenada',
            link: '//www.sandals.com/sandals-grenada/',
            value: 'sls'
          }
        ]
      },
      {
        country: {
          label: 'BARBADOS',
          link: '//www.sandals.com/barbados/',
        },
        resortList: [
          {
            resortName: 'Barbados',
            link: '//www.sandals.com/sandals-barbados/',
            value: 'sbd'
          },
          {
            resortName: 'Royal Barbados',
            link: '//www.sandals.com/royal-barbados/',
            value: 'sbr'
          }
        ]
      },
    ],
    islands: [
      {
        regionName: 'curaçao',
        link: '//www.sandals.com/curacao/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/curacao.jpg',
        isNewDestination: true,
      },
      {
        regionName: 'jamaica',
        link: '//www.sandals.com/jamaica/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/jamaica.jpg'
      },
      {
        regionName: 'bahamas',
        link: '//www.sandals.com/bahamas/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/bahamas.jpg'
      },
      {
        regionName: 'antigua',
        link: '//www.sandals.com/antigua/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/antigua.jpg'
      },
      {
        regionName: 'saint lucia',
        link: '//www.sandals.com/saint-lucia/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/saint_lucia.jpg'
      },
      {
        regionName: 'barbados',
        link: '//www.sandals.com/barbados/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/barbados.jpg'
      },
      {
        regionName: 'grenada',
        link: '//www.sandals.com/grenada/',
        img: '//cdn.sandals.com/sandals/v12/images/globals/resorts/navigation/grenada.jpg'
      },
    ],
    inclusions: [
      {
        className: 'top-menu',
        heading: {
          headerClassName: 'd-sm-none',
          label: 'What\'s Included',
          link: '//www.sandals.com/all-inclusive/',
        },
        links: [
          {
            label: 'View All Inclusions',
            link: '//www.sandals.com/all-inclusive/'
          },
          {
            label: 'Accommodations',
            link: '//www.sandals.com/all-inclusive/accommodations/'
          },
          {
            label: 'Butler Service',
            link: '//www.sandals.com/all-inclusive/butler/'
          },
          {
            label: 'Club Sandals',
            link: '//www.sandals.com/all-inclusive/sandals-club/'
          },
          {
            label: 'Best Beaches',
            link: '//www.sandals.com/all-inclusive/best-beaches/'
          },
          {
            label: 'Captivating Pools',
            link: '//www.sandals.com/all-inclusive/pools/'
          },
          {
            label: 'Gourmet Dining',
            link: '//www.sandals.com/all-inclusive/dining/'
          },
          {
            label: 'Premium Liquors',
            link: '//www.sandals.com/all-inclusive/bars/'
          },
          {
            label: 'Premium House Wines',
            link: '//www.sandals.com/all-inclusive/mondavi-wines/'
          },
          {
            label: 'Entertainment',
            link: '//www.sandals.com/all-inclusive/entertainment/'
          },
          {
            label: 'Stay At One Play At All',
            link: '//www.sandals.com/all-inclusive/multi-destinations/'
          },
          {
            label: 'Private Offshore Islands',
            link: '//www.sandals.com/all-inclusive/offshore-islands/'
          },
          {
            label: 'Scuba Diving',
            link: '//www.sandals.com/scuba/'
          },
          {
            label: 'Water Sports',
            link: '//www.sandals.com/all-inclusive/watersports/'
          },
          {
            label: 'Championship Golf',
            link: '//www.sandals.com/golf/'
          },
          {
            label: 'Land Sports',
            link: '//www.sandals.com/all-inclusive/landsports/'
          },
          {
            label: 'Fitness Centers',
            link: '//www.sandals.com/redlane-spa/fitness-centers/'
          }
        ]
      },
      {
        className: 'bottom-menu',
        heading: {
          headerClassName: 'vac-extras-header',
          label: 'Vacation Extras',
          link: '//www.sandals.com/all-inclusive/butler/',
        },
        links: [
          {
            label: 'Red Lane® Spa *',
            link: '//www.sandals.com/redlane-spa/'
          },
          {
            label: 'Local Adventure Tours *',
            link: '//www.sandals.com/tours/'
          },
          {
            label: 'Candlelight dinner *',
            link: '//www.sandals.com/all-inclusive/candlelight-dinners/'
          },
          {
            label: 'Photo & Video Services *',
            link: '//www.sandals.com/photo-video-services/'
          },
          {
            label: 'LIV+ Events *',
            link: '//www.sandals.com/liv-plus/'
          }
        ],
        additionalInformation: '* Available at additional cost'
      }
    ],
    weddings: {
      leftMenu: {
        heading: {
          label: 'Weddings',
          link: '//www.sandals.com/weddings/',
        },
        links: [
          {
            label: 'Overview',
            link: '//www.sandals.com/weddings/'
          },
          {
            label: 'Be Inspired',
            link: '//www.sandals.com/weddings/inspirations/'
          },
          {
            label: 'Décor Items',
            link: '//www.sandals.com/weddings/ideas/wishlist-catalog/'
          },
          {
            label: 'Look Books',
            link: '//www.sandals.com/weddings/ideas/look-book/'
          },
          {
            label: 'Inclusions',
            link: '//www.sandals.com/weddings/inclusions/'
          },
          {
            label: 'Locations',
            link: '//www.sandals.com/weddings/venues/'
          },
          {
            label: 'Your guests',
            link: '//www.sandals.com/weddings/guests/'
          },
          {
            label: 'Planning',
            link: '//www.sandals.com/weddings/planner/'
          },
          {
            label: 'Free Wedding',
            link: '//www.sandals.com/all-inclusive/butler/'
          },
          {
            label: 'Photo & Video',
            link: '//www.sandals.com/weddings/media/'
          },
          {
            label: 'Menu Options',
            link: '//www.sandals.com/weddings/free/'
          },
          {
            label: 'Entertainment',
            link: '//www.sandals.com/weddings/entertainment/'
          },
          {
            label: 'Wedding FAQs',
            link: '//www.sandals.com/weddings/faq/'
          }
        ],
      },
      rightMenu: [
        {
          label: 'Engagements',
          link: '//www.sandals.com/engagements'
        },
        {
          label: 'Honeymoons',
          link: '//www.sandals.com/honeymoons/'
        },
        {
          label: 'Anniversaries',
          link: '//www.sandals.com/anniversaries/'
        },
        {
          label: 'Retie the Knot',
          link: '//www.sandals.com/vow-renewals/'
        }
      ],
      weddingPromotionLink: '//www.sandals.com/weddings/promotions/',
      createOwnWeddingLink: '//www.sandals.com/weddings/ideas/'
    },
    specials: {
      heading: {
        label: 'Specials at Sandals',
        link: '//www.sandals.com/specials/',
      },
      links: [
        {
          label: 'All Specials at Sandals',
          link: '//www.sandals.com/specials/'
        },
        {
          label: 'Specials by Resort',
          link: '//www.sandals.com/specials/resort-specials/'
        },
        {
          label: '777 Offer',
          link: '//www.sandals.com/specials/best-value-suites/'
        },
        {
          label: 'Service Personnel Discount',
          link: '//www.sandals.com/specials/firefighter-military-police-savings/'
        },
        {
          label: 'Last Minute Deals',
          link: '//www.sandals.com/specials/last-minute-travel-deals/'
        },
        {
          label: 'Groups Specials',
          link: '//www.sandals.com/group-specials/'
        },
        {
          label: 'Weddings Specials',
          link: '//www.sandals.com/weddings/promotions/'
        }
      ],
      homePage: '//www.sandals.com/specials/'
    },
  },
  includes: {
    fastLinks: [
      {
        url: '//sandals.com/resorts/',
        iconClassName: 'icon-grid',
        heading: 'View All Resorts',
        description: '16 resorts on the Caribbean\'s best beaches'
      },
      {
        url: '//sandals.com/vacation-planner/',
        iconClassName: 'icon-planner',
        heading: 'NOT SURE WHICH RESORT TO PICK?',
        description: 'FIND THE RIGHT SANDALS FOR YOU'
      },
      {
        url: '//sandals.com/compare/',
        iconClassName: 'icon-compare',
        heading: 'Compare Resorts',
        description: 'Our resorts are uniquely different'
      }
    ]
  }
};

export default sandals;



// WEBPACK FOOTER //
// ./js/modules/menuData/sandals.js